
import { deleteService, getCustomerLastRequest, getServiceStatusList, getTaskList, resetRejectedService } from '../store/api/Services';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../Components/BihamtaTable";
import { useHistory } from 'react-router-dom';
import { BootstrapReboot, Calendar2Date, ChatRightText, DashCircle, DashCircleFill, EmojiAngry, EmojiSmile, EyeFill, EyeSlashFill, List, Printer, Receipt, Search, XCircle, XCircleFill } from 'react-bootstrap-icons';
import { Button, Card } from 'react-bootstrap';
import DatePicker from "react-datepicker2";
import { useForm } from 'react-hook-form';
import ModalProducts from "../Common/ModalProducts";
import { getSystemSettings } from '../store/api/SystemSettingsAPI';
import ModalServiceEvents from '../Common/ModalServiceEvents';
import ModalNewTicket from '../Common/ModalNewTicket';
const Tasks = () => {
  const history = useHistory();
  const dateFilters = useRef({});
  const { handleSubmit, register } = useForm();
  const settingNames = ['ProductGrouppingType'];

  const filterData = useRef({ Skip: 0, Take: 0 });
  const [statusList, getStatusList] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [selectedProduct, selectProduct] = useState(null);
  const [modalEvents, setModalEvents] = useState({ show: false });
  const [modalTickets, setModalTickets] = useState({ show: false });
  const [popPorduct, setProductPopup] = useState({ show: false });
  const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
  const pgType = systemSettings && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
    Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
  const dispatch = useDispatch();
  function printInvoice(row) {
    history.push({
      pathname: `/PrintViewer/ServiceInvoice/${row.e.ctrlKey}`,
      state: {
        dataUrl: `ReceptionTasksApi/GetServiceInvoice?serviceID=${row.ServiceID}&serviceType=${row.ServiceType}`,
        method: "get"
      }
    });
  }
  function printCustomerReceipt(row) {
    history.push({
      pathname: `/PrintViewer/ServiceReceipt/${row.e.ctrlKey}`,
      state: {
        dataUrl: `ReceptionTasksApi/GetServiceReceipt?serviceID=${row.ServiceID}&serviceType=${row.ServiceType}`,
        method: "get"
      }
    });
  }
  function showModalEvents(row) {
    setModalEvents({
      show: true,
      ServiceID: row.ServiceID,
      ServiceType: row.ServiceType
    })
  }
  function showModalTickets(row) {
    setModalTickets({
      show: true,
      formAttachmentType: row.ServiceType,
      formAttachmentID: row.ServiceID,
      defaultSubject: `ارجاع به درخواست ${row.PServiceType} شماره ${row.InvoiceNumber}: `
    });
  }
  const tableColes = [
    { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
    { colTitle: " نوع درخواست", colName: "PServiceType", justInMobile: true },
    { colTitle: " وضعیت درخواست", colName: "PStatusName", justInMobile: true },
    { colTitle: "شماره درخواست", colName: "InvoiceNumber", justInMobile: true },
    { colTitle: "تاریخ درخواست", colName: "PDate", justInMobile: true },
    { colTitle: "مارک محصول", colName: "HolderName", justInMobile: false, showCondition: () => pgType !== 1 },
    { colTitle: pgType === 1 ? "نام محصول" : "نوع محصول", colName: "ProductName", justInMobile: false },
    { colTitle: "مدل محصول", colName: "ProductModel", justInMobile: false },
    { colTitle: "شماره سریال", colName: "SerialNumber", justInMobile: false },
    { colTitle: "تکنسین اعزامی", colName: "StaffName", justInMobile: false },
    { colTitle: "شماره همراه", colName: "StaffMobile", justInMobile: false },
    { colTitle: "تاریخ اعزام", colName: "PSendDate", justInMobile: false }
  ]
  const tableRowButtons = [
    {
      title: "رضایت سنجی", type: "common", className: "group-Btn-smalll btn-danger",
      onclick: (item) => { history.push(`/Happycall/${item.ServiceID}/${item.ServiceType}`); },
      showCondition: showButtons,
      tooltip: "رضایت سنجی",
      icon: <EmojiSmile className="rowBtn" style={{ color: "green" }} size={19} />
    },
    {
      title: "ثبت شکایت", type: "common", className: "group-Btn-smalll btn-success",
      onclick: (item) => { history.push(`/Complaint/${item.ServiceID}/${item.ServiceType}/${item.InvoiceNumber}/${(item.SerialNumber ?? '').length ===0?" ": item.SerialNumber}/${item.ProductID}`); },
      showCondition: showButtons,
      tooltip: "شکایت",
      icon: <EmojiAngry size={18} style={{ color: "red" }} className="rowBtn" />
    },
    {
      title: "فاکتور خدمات", type: "common", className: "group-Btn-smalll btn-primary",
      onclick: (item) => printInvoice(item),
      showCondition: showButtons,
      tooltip: "فاکتور خدمات",
      icon: <Printer color="#055599" size={18} className="rowBtn" />
    },
    {
      title: "رسید مشتری", type: "common", className: "group-Btn-smalll btn-primary",
      onclick: (item) => printCustomerReceipt(item),
      tooltip: "رسید مشتری",
      showCondition: (item) => item.StatusName !== "WatingForReception",
      icon: <Receipt color="#4600ff" size={18} className="rowBtn" />
    },
    {
      title: "درخواست مجدد", type: "common", className: "group-Btn-smalll btn-primary",
      onclick: (item) => { resetService(item) },
      showCondition: showResetService,
      tooltip: "درخواست مجدد",
      icon: <BootstrapReboot color="#055599" size={18} className="rowBtn" />
    },
    {
      title: "رویدادها", type: "common", className: "group-Btn-smalll btn-info",
      onclick: (item) => { showModalEvents(item) },
      tooltip: "رویدادها",
      icon: <Calendar2Date color="#d62b95" size={18} className="rowBtn" />
    },
    {
      title: "ثبت تیکت", type: "common", className: "group-Btn-smalll btn-info",
      tooltip: "ثبت تیکت",
      onclick: (item) => { showModalTickets(item) },
      showCondition: (item) => item.StatusName === "WaitingForReception" || item.StatusName === "sent" || item.StatusName === "reception",
      icon: <ChatRightText color="#106585" size={18} className="rowBtn" />
    },
    {title:"لغو درخواست", type:"common", className:"group-Btn-small btn-danger", tooltip:"لغو درخواست", 
    onclick:(item)=> deleteRequest(item), icon:<XCircle size={18} color='red'/>,
    showCondition: (item) => item.StatusName === "WaitingForReception"}

  ]
  const deleteRequest = (service) => {
    const lastServiceType = localStorage.getItem("LastServiceType");
    const lastServiceID = localStorage.getItem("LastServiceID");
    dispatch(deleteService(service.ServiceType, service.ServiceID, () => {
      if(service.ServiceType === lastServiceType && Number(service.ServiceID) === Number(lastServiceID))
      {
        localStorage.removeItem("LastServiceID");
        localStorage.removeItem("LastServiceType");
        dispatch(getCustomerLastRequest(null, null));
      }
      dispatch(getTaskList(filterData.current));
    }))
}
  function showButtons(item) {
    return item.StatusName === "done";
  }
  function showResetService(item) {
    return item.StatusName === "rejected";
  }
  function resetService(item) {
    dispatch(resetRejectedService(item.ServiceType, item.ServiceID, () => {
      localStorage.setItem("countValue", 600000);
      localStorage.setItem("now", Date.now());
      history.push("/LastRequest");
    }));
  }
  function search(data) {
    const dateFrom = document.getElementsByName("DateFrom")[0]?.value;
    if (dateFrom && dateFrom !== "") {
      data.FirstContactDate = dateFilters.current.FirstContactDate;
    }
    const dateTo = document.getElementsByName("DateTo")[0]?.value;
    if (dateTo && dateTo !== "") {
      data.ContactDateTo = dateFilters.current.ContactDateTo;
    }
    filterData.current = { ...data };
    dispatch(getTaskList(data));
  }
  function showModalProducts() {
    setProductPopup({
      show: true,
      setProductData: selectProduct
    })
  }
  useEffect(async () => {
    document.body.classList = "notMain";
    if (!systemSettings || systemSettings.length === 0) {
      dispatch(getSystemSettings(settingNames));
    }
    getServiceStatusList(getStatusList);
    const inputInvoiceNumber = document.getElementsByName("InvoiceNumber")[0];
    inputInvoiceNumber.focus();

  }, []);
  return (
    <div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
      <br />
      <ModalServiceEvents popData={modalEvents} setPopData={setModalEvents} />
      <ModalProducts productGrouppingType={pgType} popData={popPorduct} setPopupData={setProductPopup} />
      <ModalNewTicket popData={modalTickets} setPopData={setModalTickets} />
      <Card>
        <Card.Header className='headerStyle'>درخواستهای من</Card.Header>
        <Card.Body className='bodyStyle mt-1' style={{ padding: "4px", textAlign: "right" }}>
          <form readOnly onSubmit={handleSubmit(search)}>
            <button className="btn" type='button' style={{ position: "absolute", left: "2px", top: "33px", padding: 0 }} onClick={() => setShowFilters(!showFilters)}>
              {showFilters && <EyeSlashFill size={25} color="blue" />}{!showFilters && <EyeFill size={25} color="blue" />}
            </button>
            {
              showFilters &&
              <div className='row filter-area'>
                <div className='form-group col-md-2'>
                  <label>از تاریخ:‏</label>
                  <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DateFrom"
                    onChange={value => dateFilters.current.FirstContactDate = value.local("en").format("YYYY-MM-DD")} />
                </div>
                <div className='form-group col-md-2'>
                  <label>تا تاریخ:‏</label>
                  <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DateTo"
                    onChange={value => dateFilters.current.ContactDateTo = value.local("en").format("YYYY-MM-DD")} />
                </div>
                <div className='form-group col-md-2'>
                  <label>شماره درخواست</label>
                  <input type='text' className='form-control' name="InvoiceNumber" ref={register({})} />
                </div>
                <div className='form-group col-md-2'>
                  <label>وضعیت درخواست</label>
                  <select className='form-control' defaultValue="" name="StatusID" ref={register({})}>
                    <option value="">انتخاب کنید</option>
                    {statusList && Array.isArray(statusList) && statusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                  </select>
                </div>
                <div className='form-group col-md-2'>
                  <label> سریال محصول</label>
                  <input type='text' className='form-control' name="SerialNumber" ref={register({})} />
                </div>
                <div className='form-group col-md-2'>
                  <label> مشخصات محصول</label>
                  <input type='hidden' name='ProductID' ref={register({})} readOnly value={selectedProduct ? selectedProduct.ProductID : ""} />
                  <input type='text' className='form-control' readOnly value={selectedProduct ? selectedProduct.ProductName : ""} onKeyDown={showModalProducts} />
                  <Button className='btn-input-tiny' onClick={showModalProducts}><List size={18} /></Button>
                </div>
              </div>
            }
            <Button type="submit" className="group-Btn-large mt-1"><Search />&nbsp;جستجوی درخواست</Button>
          </form>
          <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} searchMethod={(data) => dispatch(getTaskList(data))} reducerName="task" objectName="tasks" />
        </Card.Body>
      </Card>
    </div>
  )
}
export default Tasks;
